module.exports = __webpack_public_path__ + "static/media/8.bbb7ff41.jpeg";